import { useTranslation } from "react-i18next";
import { Box, Typography, Skeleton } from "@mui/material";

export const AchievementsSkeleton = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "achievements" });

  return (
    <Box
      sx={{
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        background: "#FFF",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <Typography
        sx={{
          color: "var(--black-100, #1C1C1C)",
          fontFamily: "Montserrat",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "24px",
        }}
      >
        {t("achievements")}
      </Typography>
      <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
        {[1, 2, 3, 4].map((index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              gap: "12px",
              borderRadius: "12px",
              border: "1px solid var(--Gray-200, #E4E7EC)",
              background: "var(--Base-White, #FFF)",
              width: "calc(50% - 8px)",
              padding: "16px",
            }}
          >
            <Skeleton variant="circular" width={24} height={24} />
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Skeleton variant="text" width="60%" height={20} />
              <Skeleton variant="text" width="40%" height={28} />
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "4px",
                alignItems: "center",
                height: "fit-content",
              }}
            >
              <Skeleton variant="circular" width={16} height={16} />
              <Skeleton variant="text" width={20} height={18} />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
